var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCennznet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.67 322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M190.29,165.89a10.74,10.74,0,0,0,11.51-1.44l51-42.18a10.7,10.7,0,0,0,3.88-8.27V83.45A71.5,71.5,0,0,0,198,13.1L132.66,1.18A71.26,71.26,0,0,0,74,16.61,72.81,72.81,0,0,0,54.75,42.47,71.43,71.43,0,0,0,0,111.89V239.21a71.36,71.36,0,0,0,58.59,70.22l65.57,12a44.57,44.57,0,0,0,8.11.6l2.41,0,2.38,0c17.36,0,33.14-5.51,45.66-15.95A71.75,71.75,0,0,0,202,280.65c17.36-4.22,32.71-15.3,43.23-31.21a71,71,0,0,0,11.43-39.37v-42a12.12,12.12,0,0,0-19.84-9.35l-48.68,40.22a12.5,12.5,0,0,0-4.07,9.25v42.38a47.53,47.53,0,0,1-.56,7.18l-1.22,0h-.11a25.72,25.72,0,0,1-5.51-.21l-65.34-11.92A47.19,47.19,0,0,1,72.6,199.21V72.14a46.65,46.65,0,0,1,.58-7.31,46.88,46.88,0,0,1,6.7.73l65.55,11.35a47.09,47.09,0,0,1,38.65,46.33V156.1A10.72,10.72,0,0,0,190.29,165.89ZM149.81,53l-65.59-12L83.88,41h-.06A47.13,47.13,0,0,1,128.3,25.09L193.64,37a47.19,47.19,0,0,1,38.73,46.43v24.23l-24,19.82v-4.26A71.35,71.35,0,0,0,149.81,53ZM107,269.56l65.34,11.93.26,0a39.21,39.21,0,0,1-5.43,5.82,46.94,46.94,0,0,1-38.6,10.16L63,285.54a47.46,47.46,0,0,1-38.65-47V111.89A47.06,47.06,0,0,1,41.24,75.72a47.59,47.59,0,0,1,7.07-4.86c0,.43,0,.86,0,1.28V199.21A71.5,71.5,0,0,0,107,269.56Zm101.4-17.94c0-.35,0-.71,0-1.06V213.74l24-19.83v16.61a47,47,0,0,1-17,36.25A46.28,46.28,0,0,1,208.37,251.62Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCennznet);
export default __webpack_public_path__ + "static/media/cennznet.b88b426ef7ad4eb110bfddceee823aff.svg";
export { ForwardRef as ReactComponent };